export default "__VITE_ASSET__6e3098bd__"